'use client'

import { type LucideIcon } from 'lucide-react'

import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/shared/components/ui/sidebar'
import { Home, Inbox, Search, Sparkles, User } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

export const MainNavMenu = () => {
    const workspaceMenu = [
        {
            title: 'Home',
            url: '/dashboard',
            icon: Home,
            isActive: true,
        },
        // {
        //     title: 'Ask AI',
        //     url: '#',
        //     icon: Sparkles,
        // },

        // {
        //     title: 'Inbox',
        //     url: '#',
        //     icon: Inbox,
        //     badge: '10',
        // },
    ]
    return <NavMain items={workspaceMenu} />
}

function NavMain({
    items,
}: {
    items: {
        title: string
        url: string
        icon: LucideIcon
        isActive?: boolean
    }[]
}) {
    const { pathname } = useLocation()
    return (
        <SidebarMenu>
            {items.map((item) => (
                <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild isActive={item.isActive || pathname === item.url}>
                        <Link to={item.url}>
                            <item.icon />
                            <span>{item.title}</span>
                        </Link>
                    </SidebarMenuButton>
                </SidebarMenuItem>
            ))}
        </SidebarMenu>
    )
}
